import { createCrudHooks } from './base'
import type {
  VisitWithRelations,
  Visit,
  CreateVisitWithAttendees,
  UpdateVisit,
} from '@markku/types'

export const visitHooks = createCrudHooks<
  VisitWithRelations,
  Visit,
  CreateVisitWithAttendees,
  UpdateVisit
>('visit')
